import { Button, Heading, Link, Section } from 'components'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import slugify from 'utils/slugify'
import * as Styles from './TempBlog.module.css'

const TempBlog = () => {
  const data = useStaticQuery(query)

  return (
    <Section>
      <div className="space-y-8 max-w-3xl mx-auto text-center">
        <Heading type="kicker">Marketing & Lead Generation Blog</Heading>
        <Heading>
          Check our latest insights on Marketing and Lead Generation
        </Heading>
      </div>

      <div className="my-16 grid grid-cols-1 xl:grid-cols-3 gap-8">
        {data.allWpPost.nodes.map((post) => (
          <div className="shadow-gray-300-5xl rounded overflow-hidden">
            <div>
              <Link to={`/blog/${post.slug}`}>
                <Img
                  className="h-0"
                  style={{ paddingTop: '66.25%' }}
                  fluid={
                    post.featuredImage.node.localFile.childImageSharp.fluid
                  }
                />
              </Link>
            </div>

            <div className="p-8 space-y-8">
              <div className="flex space-x-2">
                {post.categories.nodes.slice(0, 2).map(({ name }) => {
                  return (
                    <div
                      data-category={slugify(name)}
                      className={Styles.category}
                    >
                      {name}
                    </div>
                  )
                })}
              </div>
              <Heading level="5">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </Heading>

              {/* <ParsedContent className="text-gray-500">
                {post.excerpt}
              </ParsedContent> */}

              <Button
                className="px-0 mt-2 leading-loose"
                type="text"
                icon={{ name: 'RiArrowRightSLine', position: 'right' }}
                to={`/blog/${post.slug}`}
              >
                Keep Reading
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default TempBlog

export const query = graphql`
  {
    allWpPost(limit: 3) {
      nodes {
        id
        title
        slug
        excerpt
        featuredImage {
          node {
            localFile {
              childImageSharp {
                id
                fluid(quality: 70, maxWidth: 240, maxHeight: 240) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`
